import { ServiceBookingStatus } from '../models';

export class ServiceBookingConstant {
  static readonly SERVICE_BOOKING_STATUS_MAPPER: Record<
    ServiceBookingStatus,
    string
  > = {
    [ServiceBookingStatus.Scheduled]: 'services.scheduled',
    [ServiceBookingStatus.InProgress]: 'services.inProgress',
    [ServiceBookingStatus.AwaitingCheckout]: 'services.awaitingCheckout',
    [ServiceBookingStatus.Closed]: 'services.closed',
    [ServiceBookingStatus.Cancelled]: 'services.cancelled',
    [ServiceBookingStatus.NoShow]: 'services.noShow',
    [ServiceBookingStatus.Voided]: 'services.voided'
  };
}
